/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { DatasourceJobParams } from './DatasourceJobParams';
import type { ExecutePreparedStatementJobAction } from './ExecutePreparedStatementJobAction';
import type { ExecuteStatementJobAction } from './ExecuteStatementJobAction';
import type { GetSchemasInDatabaseJobAction } from './GetSchemasInDatabaseJobAction';
import type { GetTablesJobAction } from './GetTablesJobAction';
import type { OAuth2MicrosoftEntraIDConnectionParams } from './OAuth2MicrosoftEntraIDConnectionParams';
import type { SnowflakeNativeAppConnectionParams } from './SnowflakeNativeAppConnectionParams';
import type { UserPasswordConnectionParams } from './UserPasswordConnectionParams';
import type { UserPrivateKeyConnectionParams } from './UserPrivateKeyConnectionParams';

export type JdbcDatasourceJobParams = (DatasourceJobParams & {
    action?: (ExecutePreparedStatementJobAction | ExecuteStatementJobAction | GetSchemasInDatabaseJobAction | GetTablesJobAction);
    connectionParams?: (OAuth2MicrosoftEntraIDConnectionParams | SnowflakeNativeAppConnectionParams | UserPasswordConnectionParams | UserPrivateKeyConnectionParams);
    datasourceType?: JdbcDatasourceJobParams.datasourceType;
} & {
    action: (ExecutePreparedStatementJobAction | ExecuteStatementJobAction | GetSchemasInDatabaseJobAction | GetTablesJobAction);
    connectionParams: (OAuth2MicrosoftEntraIDConnectionParams | SnowflakeNativeAppConnectionParams | UserPasswordConnectionParams | UserPrivateKeyConnectionParams);
    datasourceType: JdbcDatasourceJobParams.datasourceType;
});

export namespace JdbcDatasourceJobParams {

    export enum datasourceType {
        ORACLE = 'ORACLE',
        MYSQL = 'MYSQL',
        POSTGRES = 'POSTGRES',
        SNOWFLAKE = 'SNOWFLAKE',
    }


}
